var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bb-annotating',_vm._g(_vm._b({attrs:{"type":"analysing","intro":"Start creating your Visual Analysis block by adding a "}},'bb-annotating',_vm.$props,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }